import React from "react";
import ProductCard from "./ProductCard";
import { normaliseSystem } from "../constants/productCatalogue";

function greeting() {
  const hour = new Date().getHours();
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

export default function SystemRouterLanding({
  user,
  tenant,
  systems,
  prominentActions = false,
  emptyTitle = "No systems are allocated yet.",
  emptyMessage = "Contact your Platform Administrator if you expected system access.",
}) {
  const firstName = String(user?.displayName || user?.email || "there")
    .trim()
    .split(/\s+/)[0];
  const products = (systems || [])
    .map((system) => normaliseSystem(system, tenant))
    .filter(Boolean);

  return (
    <div className="pa-system-landing">
      <section className="pa-system-hero">
        <div>
          <p>Your AndUs workspace</p>
          <h1>
            {greeting()}, {firstName}.
          </h1>
          <span>
            Choose a system to continue. Only allocated platforms and roles
            appear here.
          </span>
        </div>
        <div className="pa-allocation-summary">
          <strong>{products.length}</strong>
          <span>
            systems
            <br />
            allocated
          </span>
          <small>
            <i />
            Identity verified
          </small>
        </div>
      </section>
      <section className="pa-products" aria-labelledby="pa-your-systems">
        <header>
          <div>
            <h2 id="pa-your-systems">Your systems</h2>
            <p>
              Access is determined by your workspace role and the role assigned
              inside each system.
            </p>
          </div>
          <span>{products.length} available</span>
        </header>
        {products.length ? (
          <div className="pa-product-grid">
            {products.map((system) => (
              <ProductCard
                key={system.key}
                system={system}
                actionLabel={
                  prominentActions ? `Open ${system.displayName}` : undefined
                }
              />
            ))}
          </div>
        ) : (
          <div className="pa-empty-panel">
            <h3>{emptyTitle}</h3>
            <p>{emptyMessage}</p>
          </div>
        )}
      </section>
    </div>
  );
}
